/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 12 2024
 **/

import { atom } from "jotai";

export const OpenPeopleDetailIsMeAtom = atom<boolean>(false);
export const OpenPeopleDetailUserData = atom<WebServices.People.List.User | null>(null);
export const OpenPeopleDetailIsLoadedAtom = atom<boolean>(false);
export const OpenPeopleDetailUserID = atom<string>("");

export const PeopleManageTabAtom = atom<Nullable<{ peopleGroup: string; friend: string }>>({
	peopleGroup: "people-group",
	friend: "people-friends"
});
